import {combineReducers} from 'redux';
import auth from './authReducer';
import directory from './directoryReducer';
import history from './historyReducer';
import property from './propertyReducer';
import ws from './wsReducer';

const appReducer = combineReducers({
    auth,
    directory,
    history,
    property,
    ws,
});

export default appReducer;
